export const StudentQuizProgressTranslations = {
  VIEW_QUIZZ_DETAIL: {
    es: 'Ver detalle',
    en: 'View details',
    cat: 'Veure detalls',
    eus: 'Ikusi xehetasuna',
    pt: 'Ver detalhes'
  },
  PRACTICE: {
    es: 'Practicar',
    en: 'Practice',
    cat: 'Practicar',
    eus: 'Jarraitu',
    pt: 'Practicar'
  },
  CORRECT_ANSWERS: {
    es: 'Aciertos',
    en: 'Correct',
    cat: 'Correctes',
    eus: 'Erantzun zuzenak',
    pt: 'Respostas corretas'
  },
  WRONG_ANSWERS: {
    es: 'Fallos',
    en: 'Incorrect',
    cat: 'Incorrectes',
    eus: 'Erantzun okerrak',
    pt: 'Respostas erradas'
  },
  BLANK_ANSWERS: {
    es: 'En blanco',
    en: 'Blank',
    cat: 'En blanc',
    eus: 'Ezabatu',
    pt: 'Em branco'
  },
  TOP_SCORE_SORT: {
    es: 'Resultado más alto',
    en: 'Highest score',
    cat: 'Resultat més alt',
    eus: 'Eskubide mairuena',
    pt: 'Resultado mais alto'
  },
  MIN_SCORE_SORT: {
    es: 'Resultado más bajo',
    en: 'Lowest score',
    cat: 'Resultat més baix',
    eus: 'Eskubide txikiena',
    pt: 'Resultado mais baixo'
  },
  QUIZ_RESULT_THEMES_COUNT: {
    es: '{{count}} temas',
    en: '{{count}} themes',
    cat: '{{count}} temes',
    eus: '{{count}} gaiak',
    pt: '{{count}} temas'
  },
  QUIZ_RESULT_COURSES_COUNT: {
    es: '{{count}} cursos',
    en: '{{count}} courses',
    cat: '{{count}} cursos',
    eus: '{{count}} ikastazkiak',
    pt: '{{count}} cursos'
  },
  QUIZ_RESULT_SORTER: {
    es: 'Ordenar por:',
    en: 'Sort by:',
    cat: 'Ordenar per:',
    eus: 'Eskubidez:',
    pt: 'Ordenar por:'
  },
  ALPHABETICAL_SORT: {
    es: 'Orden alfabético',
    en: 'Alphabetical',
    cat: 'Alfabètic',
    eus: 'Alfabetikoa',
    pt: 'Alfabético'
  },
  MORE_SUCCESSFUL_ANSWERS_SORT: {
    es: 'Más aciertos',
    en: 'More correct answers',
    cat: 'Més respostes correctes',
    eus: 'Erantzun zuzen gehiago',
    pt: 'Mais respostas corretas'
  },
  MORE_WRONG_ANSWERS_SORT: {
    es: 'Más fallos',
    en: 'More incorrect answers',
    cat: 'Més respostes errades',
    eus: 'Erantzun okerrak gehiago',
    pt: 'Mais respostas erradas'
  },
  MORE_BLANK_ANSWERS_SORT: {
    es: 'Más en blanco',
    en: 'More blank answers',
    cat: 'Més en blanc',
    eus: 'Ezabatu gehiago',
    pt: 'Mais em branco'
  },
  THEMES_SORT: {
    es: 'Temas',
    en: 'Themes',
    cat: 'Temes',
    eus: 'Gaiak',
    pt: 'Temas'
  }
};
